/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Adicional from "../Formularios/Formulario_Adicional";
import {theme} from "../../Tema";
import {subirMultiplesImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingFile";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";

const Dialogo_Adicionales = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, nuevoAviso, terminar, iniciarCarga} = useCargador({logoRedondo: logo,funcionUno: cerrar, funcionDos: realizado})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Guardando Datos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        let resultadoImgs = await subirMultiplesImagenHostingFile(entidad.imgs)
        entidad.img = resultado.data
        entidad.imgs = resultadoImgs.data
        nuevoAviso({aviso: 'Imagenes subida'})

        let dox = await guardarDoc('adicionales', entidad)
        await guardarFechaAct('adicionales')
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('adicionales', datos.id)
        terminar({aviso: 'Adicional borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >
            <Cargador/>

            <Avisos/>



            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Adicional props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        sx={{color: theme.palette.primary.main, px: 1}}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Adicionales